import React from 'react';
import { string, object } from 'yup';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '../../config';
import SelectAllBtn from '~/commons/components/SelectAllBtn.jsx';

const schema = object({
  title: string().required(),
  path: string().required(),
});

const defaults = {
  popup: false,
  popupFreq: 'once',
  frontpage: true,
  title: '',
  coverImg: null,
  content: '',
  lv: Object.keys(env.lvs),
  path: 'app',

  publishAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '08:00',
  },
  expiresAt: '',
};

const spliceIntoChunks = (arr, chunkSize) => {
  const res = [];
  while (arr.length > 0) {
    const chunk = arr.splice(0, chunkSize);
    res.push(chunk);
  }
  return res;
};

const FormAnnouncement = ({
  announcement: ann,
}) => {
  const { t, i18n: { language } } = useTranslation();
  return (
  <FormResource
    {...{
      defaults,
      schema,
      stored: ann ? {
        ...ann,
        publishAt: {
          date: moment.tz(ann.publishAt, 'Asia/Hong_Kong').format('YYYY-MM-DD'),
          time: moment.tz(ann.publishAt, 'Asia/Hong_Kong').format('HH:mm'),
        },
        expiresAt: ann.expiresAt
          ? moment.tz(ann.expiresAt, 'Asia/Hong_Kong').format('YYYY-MM-DD')
          : '',
      } : undefined,
      api: '/api/site/announcements',
      onSubmit: (vs) => ({
        ...vs,
        coverImg: typeof vs.coverImg === 'string'
          ? vs.coverImg : '',
        publishAt: moment.tz(
          `${vs.publishAt.date} ${vs.publishAt.time}`,
          'YYYY-MM-DD HH:mm',
          'Asia/Hong_Kong',
        ).utc().toDate(),
        expiresAt: vs.expiresAt
          ? moment.tz(vs.expiresAt, 'Asia/Hong_Kong').endOf('d').utc().toDate()
          : null,
      }),
    }}
  >
    <div className="row">
      <div className="col-auto">
        <div className="form-group">
          <label>{t('Show in Frontpage')}</label>
          <FormCheckGroup
            name="frontpage"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
        <div className="form-row">
          <div className="col-auto">
            <div className="form-group">
              <label>{t('Popup')}</label>
              <FormCheckGroup
                name="popup"
                type="checkbox"
                label=""
                asSwitch
              />
            </div>
          </div>
          <div className="col-auto">
            <FormGroup
              className="mt-4"
              name="popupFreq"
              label={null}
              as="select"
            >
              <option value="once">{t('Once')}</option>
              <option value="everyday">{t('Everyday')}</option>
            </FormGroup>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup name="publishAt.date" label={t('Publish At')} type="date" />
          </div>
          <div className="col">
            <FormGroup name="publishAt.time" type="time" label={t('Time')} />
          </div>
        </div>
        <FormGroup name="expiresAt" label={t('Expires At')} type="date" />
      </div>
    </div>
    <div className="form-group">
      <label>{t('Competition Group')} *</label>
      <SelectAllBtn
        name="lv"
        list={Object.keys(env.lvs)}
      />
      <div className="form-row">
        {spliceIntoChunks(Object.keys(env.lvs), 6).map((arr) => (
          <div key={arr} className="col">
            {arr.map((key) => (
              <FormCheckGroup
                key={key}
                name="lv"
                type="checkbox"
                value={key}
                label={env.lvs[key][language === 'en' ? 'en' : 'zhhk']}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
    <FormGroup name="title" label={t('Title')} />
    <FormGroup name="path" as="select" label={t('Path')}>
      <option value="home">home</option>
      <option value="app">app</option>
    </FormGroup>
    <FormGroup
      name="coverImg"
      as="coverImg"
      api="/api/site/view-slots/files"
      label={t('Cover Image')}
    />
    <FormGroup
      name="content"
      as="summernote"
      fileUploadUrl="/api/site/view-slots/files"
      label={t('Content')}
    />
  </FormResource>
  );
};

export default FormAnnouncement;
